import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a83c525c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a83c525c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83c525c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a83c525c')) {
      api.createRecord('a83c525c', component.options)
    } else {
      api.reload('a83c525c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a83c525c&scoped=true&", function () {
      api.rerender('a83c525c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HtzPjW1EL9Ne/JS/comp/Voucher.vue"
export default component.exports